<template>
  <ApplicationLayout
    :links="sidebar"
    page="Onboarding Documents"
  >
    <slot>
      <!-- Home -->
      <Home v-if="getSectionOpen === findSectionNumber('onHome') && (onboardingDone || getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')" />
      <!-- Acceptance form -->
      <AcceptanceForm v-if="getSectionOpen === findSectionNumber('acceptance') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')" />
      <!-- Personal details form -->
      <DetailsForm v-if="getSectionOpen === findSectionNumber('details') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')" />
      <!-- Salary Form -->
      <SalaryForm v-if="getSectionOpen === findSectionNumber('salary') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')" />
      <!-- Starter checklist -->
      <StarterChecklist v-if="getSectionOpen === findSectionNumber('starter') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')" />
      <!-- Apprenticeship Scheme -->
      <Apprenticeship v-if="getSectionOpen === findSectionNumber('apprenticeship') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')" />
      <!-- Prior Knowledge-->
      <PriorKnowledge v-if="getSectionOpen === findSectionNumber('priorKnowledge') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')" />
      <!-- Accommodation Request -->
      <Accommodation v-if="getSectionOpen === findSectionNumber('accommodation') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')" />
      <!-- Corporate Gear & start of section which displays if onboarding is complete-->
      <CorporateGear v-if="(getSectionOpen === findSectionNumber('corp') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')) || (getSectionOpen === 1 && onboardingDone)" :onboardingDone="onboardingDone" />
      <!-- Preparing for Induction -->
      <Induction v-if="(getSectionOpen === findSectionNumber('induction') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')) || (getSectionOpen === 2 && onboardingDone)" :onboardingDone="onboardingDone" />
      <!-- FAQs -->
      <FAQs v-if="(getSectionOpen === findSectionNumber('faq') && (getRecruit.status === 'offerLetterSent' || getRecruit.status === 'onboardingInProgress')) || (getSectionOpen === 3 && onboardingDone)" :onboardingDone="onboardingDone" />

    </slot>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '../../layouts/applicationLayout.vue'
import Home from '../../components/onboarding/Home.vue'
import SalaryForm from '../../components/onboarding/SalaryForm.vue'
import DetailsForm from '../../components/onboarding/DetailsForm.vue'
import StarterChecklist from '../../components/onboarding/StarterChecklist.vue'
import Apprenticeship from '../../components/onboarding/Apprenticeship.vue'
import PriorKnowledge from '../../components/onboarding/PriorKnowledge.vue'
import AcceptanceForm from '../../components/onboarding/AcceptanceForm.vue'
import Accommodation from '../../components/onboarding/Accommodation.vue'
import CorporateGear from '../../components/onboarding/CorporateGear.vue'
import Induction from '../../components/onboarding/Induction.vue'
import FAQs from '../../components/onboarding/FAQs.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    ApplicationLayout,
    Home,
    SalaryForm,
    DetailsForm,
    StarterChecklist,
    Apprenticeship,
    PriorKnowledge,
    AcceptanceForm,
    Accommodation,
    CorporateGear,
    Induction,
    FAQs
},
  computed: {
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getSectionOpen: 'authStore/getSectionOpen',
      getOnboardingSidebar: 'authStore/getOnboardingSidebar'
    }),
    onboardingDone(){
      const completeStatuses = ["onboardingComplete", "referencesChased", "referencesRecieved", "referencesRequested" ];
      return completeStatuses.includes(this.getRecruit.status);
    }
  },
  data () {
    return {
      sidebar: [],
    }
  },
  async created () {
    // Set recruit object from local storage
    if (localStorage.getItem('token')) {
      this.$store.dispatch('authStore/loginWithToken', localStorage.getItem('token'), { root: true })
    }
    this.currentOnboardingFormAction(this.getRecruit.onboarding)
    this.generateSidebar()
  },
  methods: {
    ...mapActions({
      selectAddressAction: 'authStore/selectAddressAction',
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      setRecruitAction: 'authStore/setRecruitAction',
    }),
    generateSidebar(){
      const sideBarArr = [{ linkName: 'Onboarding Home', icon: 'house', validationName: 'onHome', sectionNum: 0, onCompleteSectionNum: 0 }]
      let sectionNum = 1;
      if (this.getOnboardingSidebar.includes('offerAcceptanceButton')) {
        sideBarArr.push({ linkName: 'Offer Acceptance', icon: 'hand-thumbs-up', validationName: 'acceptance', sectionNum })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('yourDetails')) {
        sideBarArr.push({ linkName: 'Personal Details', icon: 'file-earmark-medical', validationName: 'details', sectionNum })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('salaryDetails')) {
        sideBarArr.push({ linkName: `Bank Details - ${window.siteVar.referer === 'UK' ? 'UK' : 'Ireland'}`, icon: 'credit-card', validationName: 'salary', sectionNum })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('starterChecklist')) {
        sideBarArr.push({ linkName: 'HMRC Starter Checklist', icon: 'receipt', validationName: 'starter', sectionNum })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('apprenticeship')) {
        sideBarArr.push({ linkName: 'Apprenticeship Scheme', icon: 'receipt', validationName: 'apprenticeship', sectionNum })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('priorKnowledge')) {
        sideBarArr.push({ linkName: 'Prior Knowledge', icon: 'receipt', validationName: 'priorKnowledge', sectionNum })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('accommodationInfo')) {
        sideBarArr.push({ linkName: 'Accommodation Request', icon: 'building', validationName: 'accommodation', sectionNum })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('dressStandards')) {
        sideBarArr.push({ linkName: 'Corporate Gear', icon: 'sunglasses', validationName: 'corp', sectionNum, onCompleteSectionNum: 1 })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('generalInfo')) {
        sideBarArr.push({ linkName: 'Preparing for Induction', icon: 'laptop', validationName: 'induction', sectionNum, onCompleteSectionNum: 2 })
        sectionNum++;
      }
      if (this.getOnboardingSidebar.includes('FAQs')) {
        sideBarArr.push({ linkName: 'FAQ\'s', icon: 'question-circle', validationName: 'faq', sectionNum, onCompleteSectionNum: 3 })
        sectionNum++;
      }
      if (this.onboardingDone){
        //only show 'CorporateGear', 'Induction' & 'FAQs' if onboarding is complete
        const tmpSideBar = sideBarArr.filter(item => item.onCompleteSectionNum >= 0).map((filtered, i) => {
          return {... filtered, sectionNum: i}
        })
        this.sidebar = tmpSideBar
      } else {
        this.sidebar = sideBarArr
      }
    },
    findSectionNumber(sectionName){
      const section = this.sidebar.find(link => link.validationName === sectionName);
      if (!section) return null;
      return this.getRecruit.status === 'onboardingComplete' ? section.onCompleteSectionNum : section.sectionNum;
    }
  }
}
</script>

<style scoped>

</style>
